var map = {
	"./CloudBattery-1-dark.svg": "egIs",
	"./CloudBattery-1-light.svg": "uLYe",
	"./CloudBattery-2-dark.svg": "wo09",
	"./CloudBattery-2-light.svg": "qyIm",
	"./CloudBattery-3-dark.svg": "QBUE",
	"./CloudBattery-3-light.svg": "KeGR",
	"./FloatingFile-1-dark.svg": "qPul",
	"./FloatingFile-1-light.svg": "m0Kl",
	"./FloatingFile-2-dark.svg": "Ip6D",
	"./FloatingFile-2-light.svg": "bjRJ",
	"./FloatingFile-3-dark.svg": "tHVx",
	"./FloatingFile-3-light.svg": "o4/G",
	"./SocialDrop-1-dark.svg": "mTB8",
	"./SocialDrop-1-light.svg": "wjwu",
	"./SocialDrop-2-dark.svg": "usf4",
	"./SocialDrop-2-light.svg": "F/0W",
	"./SocialDrop-3-dark.svg": "XKZr",
	"./SocialDrop-3-light.svg": "979R",
	"./Unify-1-dark.svg": "JJW2",
	"./Unify-1-light.svg": "zZES",
	"./Unify-2-dark.svg": "29f4",
	"./Unify-2-light.svg": "wLuy",
	"./Unify-3-dark.svg": "tB3N",
	"./Unify-3-light.svg": "giEM"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ipkA";